export const DEFAULT_AFFINITIES = ['#my', '#channel', '#themes'];

export const DEFAULT_CONTENT_STRENGTHS = ['My', 'Content', 'Strengths'];

export const DEFAULT_EXPERIENCE = ['My', 'Brand', 'Experience'];
